import { createContext, useContext } from "react";

import { TFormContext } from "./types";

export const FormContext = createContext({} as TFormContext<any>);

export const useFormContext = <T = any>(): TFormContext<T> => useContext(FormContext);
